import TableCstm from "../../../../TableCstm/TableCstm";
import './studentPaymentsInfo.scss';
import { formatDataPaymentHistory, formatMoney, paymentHistoryFormat } from "../../../../../utils/format";
import Button from "../../../../button/button";
import ChangePaymentPlan from "./changePaymentPlan";
import { useEffect, useState } from "react";
import Modal from "../../../../modal/modal";
import PaymentHistory from "../../../Payments/PaymentReceipt/PaymentHistory/PaymentHistory";
import { GetAllPaymentInfoByStudent } from "../../../../../utils/Apis/receptionApis";
import RePrintReceipt from "../../../Payments/PaymentReceipt/PaymentConfirm/RePrintReceipt/RePrintReceipt";
import Alert from "../../../../alert/Alert";
import PasswordAlert from "../../../../passwordAlert/passwordAlert";
import { PostReceptionistInCharge } from "../../../../../utils/Apis/apis";
import PaymentHistoryLegends from "../../../../paymentHisotryLegends/PaymentHistoryLegends";

const StudentPaymentsInfo = ({ studentSelected }) => {

    const [isOpen, setIsOpen] = useState();
    const [paymentPlan, setPaymentPlan] = useState({})
    const [student, setStudent] = useState({})
    const [isOpenPrintReceipt, setIsOpenPrintReceipt] = useState(false)
    const [receiptResultData, setReceiptResultData] = useState({})
    const [planUpdated, setPlanUpdated] = useState(false);
    //ALERT
    const [isVisibleAlert, setIsVisibleAlert] = useState(false);
    const [arrayAlerts, setArrayAlerts] = useState([])
    // State to manage the list of students in the receipt
    const [isPasswordRequired, setIsPasswordRequired] = useState(false);
    const [modalHandlers, setModalHandlers] = useState({
        handleAcceptPassword: () => { },
        handleCancelPassword: () => { },
    });
    useEffect(() => {
        const fetchData = async () => {
            try {
                const studentPaymentInfoResponse = await GetAllPaymentInfoByStudent(studentSelected.student.id);
                if (studentPaymentInfoResponse.status === 200) {
                    setPaymentPlan(studentPaymentInfoResponse.response.payment_plan)
                    const history = await paymentHistoryFormat(studentPaymentInfoResponse.response.receipt);
                    const smallStudent = formatDataToShowPaymentHistory(studentSelected, history);
                    console.log(smallStudent)
                    setStudent(smallStudent)

                } else if (studentPaymentInfoResponse.status === 201) {
                }
            } catch (error) {
                console.error("Error obteniendo historial de pagos:", error);
            }
        }
        fetchData();
    }, [planUpdated])
    const formatDataToShowPaymentHistory = (studentSelected, paymentHistory = []) => {
        return {
            id_student_section: null,
            id_student: studentSelected.student.id,

            name: `${studentSelected.student.name} ${studentSelected.student.middle_name}`.trim(),

            concepts_to_pay: {
                tuition: [],
                books: [],
                inscription: {}
            },

            id_class: studentSelected.class_info.id,

            inscription_date: studentSelected.student.inscription_date,

            paymentHistory,

            schoolarship: studentSelected.student.scholarship ?? {
                id: null,
                normal: null,
                prompt: null,
                late: null,
                enrollment: null
            },

            class_type: studentSelected.class_info.class_type,

            class_days: studentSelected.class_info.day,

            full_class_name: `${studentSelected.class_info.teacher || 'Maestro no asignado'} ${studentSelected.class_info.day} ${studentSelected.class_info.time_start} - ${studentSelected.class_info.time_end}`,

            is_online: studentSelected.class_info.is_online
        };
    };


    // Función auxiliar para mostrar alertas
    const showAlert = (type, message) => {
        const id = Math.floor(Math.random() * 100) + 1;
        const alertObj = { id, type, message };

        setArrayAlerts(oldArray => [alertObj, ...oldArray]);
        setIsVisibleAlert(true);
    };

    const columns = [
        { header: "Normal", accessor: "tuitionNormal", className: "tableCtype1 td" },
        { header: "Puntual", accessor: "tuitionPrompt", className: "tableCtype1 td" },
        { header: "Atrasado", accessor: "tuitionLate", className: "tableCtype1 td" },
        { header: "Con descuento c/4 Sem", accessor: "existDiscount", className: "tableCtype3 td" },
        { header: "Modalidad", accessor: "isOnline", className: "tableCtype3 td" },
    ];
    const data = [
        { tuitionNormal: formatMoney(paymentPlan.normal), tuitionPrompt: formatMoney(paymentPlan.prompt), tuitionLate: formatMoney(paymentPlan.late), isOnline: paymentPlan.is_online === 1 ? "ONLINE" : "PRESENCIAL", existDiscount: paymentPlan.exist_discount === 1 ? "Con descuento" : "Sin descuento" },
    ]
    const handleOpenModalChangePP = async () => {
        let confirmPassword = await ConfirmActionPassword()
        const isAllow = confirmPassword.status
        if (isAllow) {
            setIsOpen(true);
        }
    }
    const handleCloseModalChangePP = () => {
        setIsOpen(false);
    }
    const handleClosePrintReceipt = () => {
        setIsOpenPrintReceipt(false);
    }

    const ConfirmActionPassword = () => {
        return new Promise((resolve) => {
            setIsPasswordRequired(true); // Abre el modal
            // Pasas estas funciones al modal para controlar los botones
            const handleAcceptPassword = (formValues) => {
                if (formValues.employee_id !== '' && formValues.password !== '') {
                    const responseToConfirmation = PostReceptionistInCharge(formValues)
                    responseToConfirmation.then((value) => {
                        let status = value.status
                        if (value.hasOwnProperty("auth")) {
                            status = 202
                        }
                        switch (status) {
                            case 200:
                                setIsPasswordRequired(false); // Cierra el modal
                                resolve({ status: true, message: "Edicion Permitida" }); // Resuelve la promesa con "true" si acepta
                                break;
                            case 201:
                                showAlert('info', "Credenciales rechazadas para realizar la edición.")

                                break;
                            case 202:
                                showAlert('info', "Credenciales expiradas")
                                break;
                            default:
                                break;
                        }

                    })
                } else {
                    showAlert('danger', 'Ingrese el correo y la contraseña para verificar sus credenciales.')
                }
            };

            const handleCancelPassword = () => {
                setIsPasswordRequired(false); // Cierra el modal
                resolve({ status: false, message: "Operacion cancelada." }); // Resuelve la promesa con "false" si cancela
            };

            // Almacenar funciones en el estado para pasar al modal
            setModalHandlers({ handleAcceptPassword, handleCancelPassword });
        });
    };
    return (
        <>
            <div className="std-payments-info">
                <div className="payment-plan-container">
                    <h1 className='title-2'>Plan de pago</h1>
                    <TableCstm
                        columns={columns}
                        data={data}
                    />
                    <Button text={'Cambiar plan de pago'} onClick={handleOpenModalChangePP} />
                </div>
            </div>
            <PaymentHistoryLegends/>
            <PaymentHistory setIsOpenPrintReceipt={setIsOpenPrintReceipt} setReceiptData={setReceiptResultData} student={student} paymentPlan={paymentPlan} showActions={false} />
            {isOpenPrintReceipt && <RePrintReceipt isOpen={isOpenPrintReceipt} onClose={handleClosePrintReceipt} receiptData={receiptResultData} />}
            <Modal isOpen={isOpen} onClose={handleCloseModalChangePP}>
                <ChangePaymentPlan showAlert={showAlert} student={student} onClose={handleCloseModalChangePP} paymentPlan={paymentPlan} planUpdated={planUpdated} setPlanUpdated={setPlanUpdated} />
            </Modal>
            <div className="divAlert">
                <Alert arrayAlertsModule={arrayAlerts} setArrayAlertsModule={setArrayAlerts} isVisibleModule={isVisibleAlert} setIsVisibleModule={setIsVisibleAlert} />
            </div>
            {/* Password required */}
            {
                isPasswordRequired && <PasswordAlert
                    isOpen={isPasswordRequired}
                    handleAccept={modalHandlers.handleAcceptPassword}
                    handleCancel={modalHandlers.handleCancelPassword}
                    title="Confirmar con contraseña"
                />
            }
        </>
    )
}
export default StudentPaymentsInfo;
